export default __webpack_public_path__ + "static/media/regreenbus_road_img.db4612c2.jpg";